import React, { Component } from "react";
import { Modal, Button, Form } from "react-bootstrap";
import { connect } from "react-redux";
import Select from "react-select";
import withFetchHook from "../withFetchHook";

class PasswordResetFormModal extends Component {
  constructor(props) {
    super(props);
    var lastUser = props.users[props.users.length - 1]
    let selectedUser = {
      value: lastUser.id,
      label: `${lastUser.first_name} ${lastUser.last_name} [${lastUser.email}]`
    }
    this.state= {
      selectedUser,
      password: '',
    }
  }

  handleClose() {
    this.props.closeModal();
  }

  handlePasswordChange(e){
    const password = e.target.value
    this.setState(()=>({ password }))
  }

  handleSubmit() {
    const { selectedUser, password } = this.state;
    const { organizationName, passwordResetSuccess, passwordResetFailed } = this.props;
    this.props.fetch(`/organizations/${organizationName}/users/${selectedUser.value}/reset_password.json`, {
      method: "PATCH",
      data: {
        user: {
          password
        }
      }
    }).then((data) => {
      if (data.error){
        passwordResetFailed(data.error)
      } else {
        passwordResetSuccess()
      }
      this.handleClose()
    })
  }

  submitButtonEnabled(){

    return ((this.state.password.length > 5) && this.state.selectedUser != null)
  }

  render() {
    const { users } = this.props;
    const userOptions = users.map(user => ({
      value: user.id,
      label: `${user.first_name} ${user.last_name} [${user.email}]`
    }))
    const { password, selectedUser } = this.state
    return (
      <Modal show={this.props.show} onHide={this.handleClose.bind(this)}>
        <Modal.Header closeButton>
          <Modal.Title>Change Password</Modal.Title>
        </Modal.Header>
        <Modal.Body>
          {this.props.hasEdit ? (
            <>
              <Form.Group controlId="passwordResetUser">
                <Form.Label>User</Form.Label>
                <Select
                  value={selectedUser}
                  options={userOptions}
                  onChange={(option) => {
                    this.setState(()=>({ selectedUser: option }))
                  }} />
              </Form.Group>
              <Form.Group controlId="passwordResetPassword">
                <Form.Label>New Password</Form.Label>
                <Form.Control
                  type="password"
                  value={password}
                  onChange={(e) => this.handlePasswordChange(e)} />
              </Form.Group>
            </>
          ) : (
            <div className="form-control-plaintext">
              You do not have permission to reset passwords.
            </div>
          )}
        </Modal.Body>
        {this.props.hasEdit && (
          <Modal.Footer>
            <Button
              variant="info"
              disabled={!this.submitButtonEnabled()}
              onClick={() => this.handleSubmit()}>
              Change Password
            </Button>
          </Modal.Footer>
        )}
      </Modal>
    );
  }
}

const mapStateToProps = (state, ownProps) => {
  return {
    show: state.ui.passwordResetModal.show,
    users: state.users,
    residentId: state.resident.id,
    organizationName: state.organization.name,
    hasDelete: state.current_user.permissions.includes("Delete"),
    hasEdit: state.current_user.permissions.includes("Edit"),
  };
}

const mapDispatchToProps = (dispatch) => {
  return {
    closeModal: () => dispatch({ type: "CLOSE_RESOURCE_MODAL", payload: { resourceName: "passwordReset" }}),
    passwordResetSuccess: () => dispatch({ type: "PASSWORD_RESET_SUCCESS" }),
    passwordResetFailed: (error) => dispatch({ type: "PASSWORD_RESET_FAILED", payload: { error } }),
  };
}

export default withFetchHook(connect(mapStateToProps, mapDispatchToProps)(PasswordResetFormModal));
